/**
 * @generated SignedSource<<20fe8d948bbccf8d74bd468e72b4b189>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternalNav_viewer$data = {
  readonly internalNavBarLinks: {
    readonly links: {
      readonly navItems: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"useActiveNavLink_navItems">;
      } | null> | null;
      readonly " $fragmentSpreads": FragmentRefs<"NavItems_links">;
    } | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"NavItems_viewer">;
  readonly " $fragmentType": "InternalNav_viewer";
};
export type InternalNav_viewer$key = {
  readonly " $data"?: InternalNav_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternalNav_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternalNav_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItems_viewer"
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "concreteType": "InternalNavBar",
      "kind": "LinkedField",
      "name": "internalNavBarLinks",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "NavBarLinks",
          "kind": "LinkedField",
          "name": "links",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NavItems_links"
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "navItems",
              "plural": true,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "useActiveNavLink_navItems"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "723838097f882b65abe217584bfd7e82";

export default node;
